/**
 * DailyReadChatCard — Nikki's Daily Read, inline in the chat thread.
 * Thin wrapper around the shared <NikkiDailyRead/> so chat and dashboard render
 * the identical read from the same payload (build_daily_read on the backend).
 */
import React from 'react';
import NikkiDailyRead from '../../NikkiDailyRead';

const DailyReadChatCard = ({ data }) => <NikkiDailyRead data={data} variant="chat" />;

export default DailyReadChatCard;
